import { store } from './index';
import { defineStore } from 'pinia';

import { useCache } from '@/hooks/useCache';

interface AppState {
	AccountInfo: LoginInfo;
}

const { wsCache } = useCache();

export const useAppStore = defineStore('app', {
	state: (): AppState => {
		return {
			AccountInfo: wsCache.get('LoginInfo') || {},
		};
	},
	getters: {
		getLoginInfo(): any {
			return this.AccountInfo;
		},
	},
	actions: {
		setLoginInfo(infos: any) {
			wsCache.set('LoginInfo', infos);
			this.AccountInfo = Object.assign(this.AccountInfo, infos);
		},
	},
});

export const useAppStoreWithOut = () => {
	return useAppStore(store);
};
